import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M12 21.002v-8.25m3.75 8.25v-8.25m-7.5 8.25v-8.25M3 9.002l9-6 9 6m-1.5 12V10.335a48.4 48.4 0 0 0-7.5-.583c-2.551 0-5.056.2-7.5.583v10.667m-1.5 0h18m-9-14.25h.008v.008H12z"
    }, null, -1)
  ])))
}
export default { render: render }